import { Badge } from '@/components/ui/badge';
import { cn } from '@/components/ui/utils';
import { JOURNEY_STAGE_LABELS, type JourneyStage } from '@/types/journey';

// Colour tracks progress through the funnel rather than the individual stage:
// grey early, blue mid, amber while we're waiting on the prospect, green closed,
// red lost. Stalled reads as muted because it is a holding state, not a failure.
const STAGE_STYLES: Record<JourneyStage, string> = {
  intro_detected: 'bg-muted text-muted-foreground',
  intro_replied: 'bg-muted text-muted-foreground',
  booked: 'bg-info/15 text-info',
  brief_built: 'bg-info/15 text-info',
  call_done: 'bg-info/15 text-info',
  access_requested: 'bg-warning/15 text-warning',
  access_partial: 'bg-warning/15 text-warning',
  access_complete: 'bg-primary/15 text-primary',
  audit_building: 'bg-primary/15 text-primary',
  audit_published: 'bg-primary/15 text-primary',
  proposal_sent: 'bg-warning/15 text-warning',
  closed_won: 'bg-success/15 text-success',
  lost: 'bg-destructive/15 text-destructive',
  stalled: 'bg-muted text-muted-foreground',
};

export function JourneyStageBadge({ stage, className }: { stage: JourneyStage; className?: string }) {
  return (
    <Badge
      variant="outline"
      className={cn(
        'text-xs font-medium',
        STAGE_STYLES[stage] ?? 'bg-muted text-muted-foreground',
        className
      )}
    >
      {JOURNEY_STAGE_LABELS[stage] ?? stage}
    </Badge>
  );
}
